export const localesRegex = /^\/(en|am)/